import type { Tool, ToolContext, PointerInfo } from "./Tool";

/** Click-to-remove a tube. */
export class DeleteTool implements Tool {
  readonly id = "delete";
  readonly name = "Erase";
  readonly hint = "Click a tube to remove it.";
  readonly icon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 7h16" />
      <path d="M9 7V4h6v3" />
      <path d="M6 7l1 13h10l1-13" />
    </svg>`;

  onPointerDown(info: PointerInfo, ctx: ToolContext): void {
    const hits = info.raycaster.intersectObjects(ctx.design.root.children, true);
    const hit = hits.find((h) => !!ctx.design.findByObject(h.object));
    const tube = hit ? ctx.design.findByObject(hit.object) : null;
    if (!tube) return;
    ctx.design.remove(tube);
    if (ctx.getSelection() === tube) ctx.setSelection(null);
    ctx.toast("Tube removed");
  }
}
